import React from "react";
import rootStyles from "./ScheduleSelectorTitle.module.scss";
import { IScheduleSelectorTitleProps } from "./IScheduleSelectorTitle";
import useScheduleSelectorTitle from "./useScheduleSelectorTitle";

const ScheduleSelectorTitle = (props: IScheduleSelectorTitleProps) => {
    const { titleClass } = props;
    const { title, componentRef, hideComponent } =
        useScheduleSelectorTitle(props);

    if (hideComponent) return null;

    return (
        <>
            <div className={rootStyles.slotSelectionRef} ref={componentRef} />
            <div className={titleClass}>{title}</div>
        </>
    );
};

export default ScheduleSelectorTitle;
